'use client'

import { Button } from '@dd3tech/wiggui/Button'
import { Input } from '@dd3tech/wiggui/Input'
import { Modal } from '@dd3tech/wiggui/Modal'
import { useModalCreateListStore } from '../../../store/modals/modal-create-list.store'
import { useModalCreateList } from '../hooks/useModalCreateList'

export const ModalCreateList = () => {
  const { createNewList, editListName } = useModalCreateList()

  const {
    isLoading,
    setNameNewList,
    isOpen,
    nameNewList,
    onClose,
    listIdToEdit
  } = useModalCreateListStore()

  if (!isOpen) {
    return null
  }

  return (
    <Modal
      className="w-full max-w-lg"
      enableBgBlur
      onClose={isLoading ? () => ({}) : onClose}
      isOpen={isOpen}
    >
      <Modal.Header
        title={
          listIdToEdit ? 'Editar lista pública' : 'Crear nueva lista pública'
        }
        isShowCloseButton
        isShowDivider
      />
      <Modal.Body className="p-6 w-full flex gap-6 flex-col items-center justify-center">
        <Input
          name="name-list"
          value={nameNewList}
          onChange={(event) => setNameNewList(event?.target.value)}
          className="w-full"
          height="h-[52px]"
          classNameContainer="w-full"
          classNameLabel="text-secondary"
          labelText="Nombre de la lista"
        />
      </Modal.Body>
      <Modal.Footer
        className="w-full py-[9px] px-6 flex flex-row items-center justify-between gap-3"
        isShowDivider
      >
        <Button
          isDisabled={isLoading}
          onClick={onClose}
          variant="terciary"
          fullWidth
        >
          Cancelar
        </Button>
        <Button
          isLoading={isLoading}
          isDisabled={isLoading || nameNewList?.length < 2}
          onClick={listIdToEdit ? editListName : createNewList}
          variant="secondary"
          fullWidth
        >
          {listIdToEdit ? 'Editar' : 'Crear'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
